import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import Button from "@mui/material/Button";
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

import ImageSelectList from './ImageSelectList';
import classes from 'app/components/Modal/classes.module.scss';

import {
  getKnockOutProductPairs,
  createProductKnockOutPair,
  updateProductKnockoutPair,
  deleteProductKnockoutPair
} from 'app/actions/jobConfigs';

const KnockoutPairingForm = ({ isOpen, onClose, backgrounds, overlays,
  account, selectedJobConfig, getKnockOutProductPairs, createProductKnockOutPair, updateProductKnockoutPair,
  deleteProductKnockoutPair }) => {
  const [selectedPair, setSelectedPair] = useState({});
  const [showImageSelect, setShowImageSelect] = useState(false);
  const [selectedType, setSelectedType] = useState('');
  const [selectedRow, setSelectedRow] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [origData, setOrigData] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [itemsChanged, setItemsChanged] = useState(false);

  const modalStyle = {};

  modalStyle.justifyContent = 'end';
  modalStyle.marginRight = '1.5rem';

  let boxClass = classes.paper,
    boxStyle = null,
    headerVariant = 'h5';

  const [data, setData] = useState([]);

  useEffect(() => {
    if (!loaded) {
      getKnockOutProductPairs(account.id, selectedJobConfig.product_id).then((result) => {
        setData(result);
        setOrigData(result);
        setLoaded(true);
      })
    }
  }, [loaded])

  useEffect(() => {
    if (isOpen) {
      setLoaded(false);
    }
  }, [isOpen])

  useEffect(() => {
    let isChanged = false;

    if (!objectsAreSame(origData, data)) {
      isChanged = true;
    }

    setItemsChanged(isChanged);
  }, [origData, data, isOpen])

  const objectsAreSame = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; i < arr2.length; i++) {
      if (arr1[i] && arr2[0]) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      } else {
        return false;
      }
    }
    return true;
  }

  const handleSelect = (assetType, rowData, rowIndex) => {
    var pair = {};
    pair[rowIndex] = rowData
    setSelectedPair(pair);
    setSelectedIndex(rowIndex);
    setSelectedRow(rowData);
    setShowImageSelect(true);
    setSelectedType(assetType);
  }

  const bgSelectEditor = (options) => {
    var bgId = selectedPair[options.rowIndex]?.background_id || options.value;
    var background = backgrounds.find((item) => item.id === bgId);
    return <div>
      {
        background &&
        <img src={background.url} style={{ width: '50px' }} />
      } &nbsp;
      <Button variant="contained" onClick={(e) => handleSelect('bg', options.rowData, options.rowIndex)}>Select</Button>
    </div>
  }

  const overlaySelectEditor = (options) => {
    var overlayId = selectedPair[options.rowIndex]?.overlay_id || options.value;
    var overlay = overlays.find((item) => item.id === overlayId);
    return <div>
      {
        overlay &&
        <img src={overlay.url} style={{ width: '50px' }} />
      } &nbsp;
      <Button variant="contained" onClick={(e) => handleSelect('overlay', options.rowData, options.rowIndex)}>Select</Button>
    </div>
  }

  const selectedBackgroundTemplate = (option, props) => {
    if (option) {
      const background = backgrounds.find((x) => x.id === option.background_id);
      if (!background) {
        return <div></div>
      } else {
        return (
          <div className="flex align-items-center">
            <img alt={background.id} src={background.url} style={{ width: '50px' }} />
          </div>
        );
      }
    }

    return <span>{props.placeholder}</span>;
  };

  const selectedOverlayTemplate = (option, props) => {
    if (option) {
      const overlay = overlays.find((x) => x.id === option.overlay_id);
      if (!overlay) {
        return <div></div>
      } else {
        return (
          <div className="flex align-items-center">
            <img alt={overlay.id} src={overlay.url} style={{ width: '50px' }} />
          </div>
        );
      }
    }

    return <span>{props.placeholder}</span>;
  };

  const onRowEditComplete = (e) => {
    let pricing = [...data];
    let { newData, index } = e;

    pricing[index] = newData;

    setData(pricing);
  };

  const onSelectCallback = (selectedImage) => {
    const pairs = [...data];
    // const pairIndex = pairs.findIndex((item) => item.id === selectedRow.id);
    const _selectedRow = Object.assign({}, selectedRow);
    const _selectedPair = Object.assign({}, selectedPair);

    if (selectedType === 'bg') {
      _selectedRow.background_id = selectedImage.id;
      _selectedRow.background_moment_id = selectedImage.moment_id;
      _selectedPair[selectedIndex].background_id = selectedImage.id;
      _selectedPair[selectedIndex].background_moment_id = selectedImage.moment_id;
    }
    else {
      _selectedRow.overlay_id = selectedImage.id;
      _selectedRow.overlay_moment_id = selectedImage.moment_id;
      _selectedPair[selectedIndex].overlay_id = selectedImage.id;
      _selectedPair[selectedIndex].overlay_moment_id = selectedImage.moment_id;
    }

    pairs[selectedIndex] = _selectedRow;
    setSelectedPair(_selectedPair);
    setSelectedRow(_selectedRow);
    setData(pairs);
    setShowImageSelect(false);
  }

  const onSubmit = async () => {
    for (let item of data) {
      if (item.id > 0) {
        await updateProductKnockoutPair(account.id, selectedJobConfig.product_id, item.id, item);
      } else {
        await createProductKnockOutPair(account.id, selectedJobConfig.product_id, item);
      }
    }

    let forDeletes = [];
    let dataIds = data.map(d => { return d.id });
    for (let orig of origData) {
      if (orig.id && !dataIds.includes(orig.id)) {
        forDeletes.push(orig);
      }
    }

    for (let item of forDeletes) {
      await deleteProductKnockoutPair(account.id, selectedJobConfig.product_id, item.id);
    }
    onClose();
  }

  const handleAddRow = () => {
    const pairs = [...data];
    pairs.push({ id: new Date().getTime() * -1, background_id: 0, background_moment_id: 0, overlay_id: 0, overlay_moment_id: 0 });
    setData(pairs);
  }

  const handleDeleteRow = (rowIndex) => {
    const pairs = [...data];
    pairs.splice(rowIndex, 1);
    setData(pairs);
  }

  const footerBody = () => {
    return <div>
      <Button variant="contained" onClick={handleAddRow}>Add</Button>
    </div>
  }

  const deleteRowBody = (data, row) => {
    return <div>
      <IconButton aria-label="delete" onClick={() => handleDeleteRow(row.rowIndex)}>
        <DeleteIcon />
      </IconButton>
    </div>
  }

  return <Modal open={isOpen} className={classes.modal} onClose={onClose}>
    <Box className={boxClass} style={boxStyle}>
      <CloseIcon className={classes.closeIcon} onClick={onClose} />
      <Typography variant={headerVariant} className={classes.formTitle}>
        Knockout Pairs
      </Typography>
      <DataTable value={data} editMode="row" dataKey="id" onRowEditComplete={onRowEditComplete} footer={footerBody}>
        <Column header='Background' field='background_id' body={selectedBackgroundTemplate} editor={(options) => bgSelectEditor(options)} />
        <Column header='Overlay' field='overlay_id' body={selectedOverlayTemplate} editor={(options) => overlaySelectEditor(options)} />
        <Column rowEditor={true} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
        <Column body={deleteRowBody} ></Column>
      </DataTable>
      <ImageSelectList isOpen={showImageSelect} assetType={selectedType} onClose={() => setShowImageSelect(false)} selectCallback={onSelectCallback} />
      <Button className={classes.button} variant="contained" onClick={onClose}>Cancel</Button>
      <Button className={classes.button} variant="contained" disabled={!itemsChanged} onClick={() => onSubmit()}>Save</Button>
    </Box>
  </Modal>
}

const mapStateToProps = state => ({
  darkMode: state.portalReducer.darkMode,
  account: state.portalReducer.account,
  backgrounds: state.knockOutReducer.backgrounds,
  overlays: state.knockOutReducer.overlays
});

export default connect(mapStateToProps, { deleteProductKnockoutPair, getKnockOutProductPairs, createProductKnockOutPair, updateProductKnockoutPair })(KnockoutPairingForm);
